import statuses from '@/store/statuses';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    advanceInvoicesList: {
      data: [],
      status: statuses.EMPTY,
    },
    advanceInvoicesListFilters: {
      data: [],
      status: statuses.EMPTY,
    },
    advanceInvoiceClassifiers: {
      data: [],
      status: statuses.EMPTY,
    },
    advanceInvoiceUpdateData: {
      data: [],
      status: statuses.EMPTY,
    },
    advanceInvoiceMediaList: {
      data: [],
      status: statuses.EMPTY,
    },
    advanceInvoiceCreate: {
      data: [],
      status: statuses.EMPTY,
    },
    advanceInvoiceUpdate: {
      data: [],
      status: statuses.EMPTY,
    },
    advanceInvoiceDeleteAttachment: {
      data: [],
      status: statuses.EMPTY,
    },
    advanceInvoiceUpdateStatus: {
      data: [],
      status: statuses.EMPTY,
    },
    advanceInvoicePaymentApprove: {
      data: [],
      status: statuses.EMPTY,
    },
    advanceInvoicePaymentReject: {
      data: [],
      status: statuses.EMPTY,
    },
    advanceInvoiceActivity: {
      data: [],
      status: statuses.EMPTY,
    },
    advanceInvoiceDelete: {
      data: [],
      status: statuses.EMPTY,
    },
    newAdvanceInvoiceFiles: {},
  };
};

const InvoicesAdvance = {
  namespaced: true,
  state: defaultState,
  getters: {
    advanceInvoicesList: (state) => state.advanceInvoicesList,
    advanceInvoicesListFilters: (state) => state.advanceInvoicesListFilters,
    advanceInvoiceClassifiers: (state) => state.advanceInvoiceClassifiers,
    advanceInvoiceUpdateData: (state) => state.advanceInvoiceUpdateData,
    advanceInvoiceMediaList: (state) => state.advanceInvoiceMediaList,
    advanceInvoiceCreate: (state) => state.advanceInvoiceCreate,
    advanceInvoiceUpdate: (state) => state.advanceInvoiceUpdate,
    advanceInvoiceDeleteAttachment: (state) => state.advanceInvoiceDeleteAttachment,
    advanceInvoiceUpdateStatus: (state) => state.advanceInvoiceUpdateStatus,
    advanceInvoicePaymentApprove: (state) => state.advanceInvoicePaymentApprove,
    advanceInvoicePaymentReject: (state) => state.advanceInvoicePaymentReject,
    advanceInvoiceActivity: (state) => state.advanceInvoiceActivity,
    advanceInvoiceDelete: (state) => state.advanceInvoiceDelete,
    newAdvanceInvoiceFiles: (state) => state.newAdvanceInvoiceFiles
  },
  mutations,
  actions,
};

export { InvoicesAdvance, defaultState };
